<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <div v-if="showWatermark" v-watermark="{ watermarkText: watermarkText }" />
  </div>
</template>

<script>
import store from '@/store'
import { mapActions } from 'vuex'
export default {
  name: 'App',
  async created() {
    // 页面加载时尝试恢复用户信息
    if (this.$store.state.user.token && !this.$store.state.user.name) {
      try {
        await this.getUserInfo()
      } catch (error) {
        console.error('Failed to restore user info:', error)
      }
    }
  },
  data() {
    return {
      watermarkText: '', // 水印文本
      showWatermark: false // 是否显示水印
    }
  },
  computed: {
    userName() {
      return store.getters.name
    }
  },
  watch: {
    userName(newVal) {
      if (newVal) {
        this.watermarkText = newVal
        this.showWatermark = true
      } else {
        this.showWatermark = false
      }
    }
  },
  mounted() {
    this.initWatermark() // 从不同入口进入页面时，需要init一下
  },
  methods: {
    initWatermark() {
      if (this.userName) {
        this.watermarkText = store.getters.name
        this.showWatermark = true
      } else {
        this.showWatermark = false
      }
    },
    ...mapActions('user', ['getInfo']),
    getUserInfo() {
      return this.getInfo()
    }
  }
}
</script>

<style lang="scss">
#app {
  width: 100%;
  position: relative;
  height: 100%;
}
</style>
